export const PATCH_USER = 'PATCH_USER'